/**
 * @权限数据相关的hooks数据映射
 * @Date: 2022-05-25 09:53:37
 * @LastEditTime: 2022-05-25 10:00:22
 * @FilePath: \vue3-vite-templant\src\hooks\usePermission.ts
 * @Description: 通过 $subscribe 监听权限数据变化
 */
import usePermissionStore from '@/store/modules/permission.ts'
import { ref } from 'vue'

const usePermission = () => {
    // 权限相关属性
    const permissionStore = usePermissionStore()
    // 所有路由列表
    const allRoutes = ref(permissionStore.allRoutes)
    // 动态路由列表
    const dynamicsRoutes = ref(permissionStore.dynamicsRoutes)
    // 静态路由列表
    const staticRoutes = ref(permissionStore.dynamicsRoutes)
    // 侧边栏路由列表
    const sidebarRouters = ref(permissionStore.sidebarRouters)
    // 当前选中的菜单
    const activeRoute = ref(permissionStore.activeRoute)
    // 当前选中的一级路由
    const activeLevel1Route = ref(permissionStore.activeLevel1Route)
    // 当前选中的二级路由
    const activeLevel2Route = ref(permissionStore.activeLevel2Route)
    // 所有按钮权限
    const buttonPermissionList = ref(permissionStore.buttonPermissionList)
    // 监听设置变化
    permissionStore.$subscribe(() => {
        allRoutes.value = permissionStore.allRoutes
        dynamicsRoutes.value = permissionStore.dynamicsRoutes
        staticRoutes.value = permissionStore.staticRoutes
        sidebarRouters.value = permissionStore.sidebarRouters
        activeRoute.value = permissionStore.activeRoute
        activeLevel1Route.value = permissionStore.activeLevel1Route
        activeLevel2Route.value = permissionStore.activeLevel2Route
        buttonPermissionList.value = permissionStore.buttonPermissionList
    })
    // 判断权限
    const hasPermission = (permission: string) => {
        // 处理 permissions 为 null 或 undefined 的情况
        if (!buttonPermissionList.value) {
            return false
        }

        return buttonPermissionList.value.includes(permission)
    }
    return {
        // 所有路由列表
        allRoutes,
        // 动态路由列表
        dynamicsRoutes,
        // 静态路由列表
        staticRoutes,
        // 侧边栏路由列表
        sidebarRouters,
        // 当前选中的菜单
        activeRoute,
        // 当前选中的一级路由
        activeLevel1Route,
        // 当前选中的二级路由
        activeLevel2Route,
        // 所有按钮权限
        buttonPermissionList,
        // 判断权限
        hasPermission
    }
}
export default usePermission
